import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sectionMessageTitle: {
		id: 'servicedesk-sla-settings.header.awareness-banner.section-message-title',
		defaultMessage: 'This service project has improved SLAs',
		description: 'title for updated SLA Banner',
	},
	sectionMessageDescription: {
		id: 'servicedesk-sla-settings.header.awareness-banner.section-message-description',
		defaultMessage:
			'Improved SLAs allows you to add many priority-based time targets to a single goal. You can now reconfigure your SLAs based around priority to increase your overall SLA goal capacity.',
		description: 'description for updated SLA Banner',
	},
	learnMoreAboutImprovedSla: {
		id: 'servicedesk-sla-settings.header.awareness-banner.learn-more-about-improved-sla',
		defaultMessage: 'Learn how to configure SLAs by priority',
		description: 'updated action button to Learn more about improved SLAs',
	},
});
